import React from 'react'
import Navbar from "../components/Navbar";
import { useState, useEffect, useContext } from "react";
import { ThemeContext } from '../Contexts/themeProvider';
import Contact from '../views/Contact';
import ChatBot from '../LiveAi/ChatBot';
import LoadingScreen from '../components/LoadingScreen';
import { useLocation } from 'react-router-dom'; 
import ChatButton from '../LiveAi/ChatButton';
import AutoScrollSearchList from '../GoogleSearch/Components/AutoScrollSearchList';

const GoogleSearch = ({chatOpen,setChatOpen,images}) => {
    const [loading, setLoading] = useState(true)
    const theme = useContext(ThemeContext);
    const darkMode = theme.state.darkMode; 
    const location = useLocation();

    useEffect(() => {
      const hasVisited = localStorage.getItem('hasVisitedSearch');
      const delay = hasVisited ? 3000 : 7000; // 1s for next visits, 3s for first time
  
     const timeout= setTimeout(() => {
        setLoading(false);
        localStorage.setItem('hasVisitedSearch', 'true');
      }, delay);

      return () => {
        clearTimeout(timeout); // Cleanup on unmount
      };
    }, []);

    // false when user close tabs 
    useEffect(() => {
      const handleBeforeUnload = () => {
        const allowedPaths = ['/', '/galary','/google-search'];
        if (allowedPaths.includes(location.pathname)) {
          localStorage.setItem('hasVisitedSearch', 'false');
        }
      };
  
      window.addEventListener('beforeunload', handleBeforeUnload);
  
      return () => {
        window.removeEventListener('beforeunload', handleBeforeUnload);
      };
    }, [location.pathname]);
  
  return (
    <div>
      {!loading ? 
        <>
          <Navbar theme={theme} darkMode={darkMode}/>
          <AutoScrollSearchList images={images}/>
          <Contact darkMode={darkMode}/>
          {/* Chat Button */}
          <ChatButton chatOpen={chatOpen} setChatOpen={setChatOpen}/>
          
          {chatOpen && <ChatBot darkMode={darkMode} chatOpen={chatOpen} setChatOpen={setChatOpen}/>}
        </>
        :
        <LoadingScreen />
      }
    </div>
  )
}

export default GoogleSearch
